import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferAppleMusicToAppleMusic() {
    return (
        <GuidesPage
            seoData={seoContent.transferAppleMusicToAppleMusic}
            sections={<PairTransferGuideContent sourceKey="appleMusic" destKey="appleMusic" />}
        />
    );
}
